import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, resolveDirective as _resolveDirective, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "部门日报规则管理"
};
const _hoisted_2 = {
  class: "department-rule-drawer-panel absolute inset-y-0 right-0 flex h-full flex-col bg-white shadow-2xl"
};
const _hoisted_3 = {
  class: "flex shrink-0 items-center justify-between border-b border-slate-200 px-5 py-4"
};
const _hoisted_4 = {
  class: "flex items-center gap-3"
};
const _hoisted_5 = {
  class: "flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600"
};
const _hoisted_6 = {
  class: "min-h-0 flex-1 overflow-y-auto bg-slate-50 px-5 py-5"
};
const _hoisted_7 = {
  class: "grid gap-3 sm:grid-cols-3"
};
const _hoisted_8 = {
  class: "text-xs font-medium text-slate-500"
};
const _hoisted_9 = {
  class: "mt-1 text-2xl font-semibold text-slate-900"
};
const _hoisted_10 = {
  class: "mt-4 rounded-xl border border-slate-200 bg-white shadow-sm"
};
const _hoisted_11 = {
  class: "flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-4 py-3"
};
const _hoisted_12 = ["disabled"];
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center gap-3 px-6 py-14 text-center"
};
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col items-center gap-3 px-6 py-14 text-center"
};
const _hoisted_15 = {
  class: "flex h-12 w-12 items-center justify-center rounded-full bg-rose-100"
};
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col items-center gap-3 px-6 py-14 text-center"
};
const _hoisted_17 = {
  class: "empty-state-icon"
};
const _hoisted_18 = {
  key: 3,
  class: "data-table-scroll max-h-[56vh]"
};
const _hoisted_19 = {
  class: "data-table"
};
const _hoisted_20 = {
  class: "data-table-body"
};
const _hoisted_21 = {
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "font-medium text-slate-900"
};
const _hoisted_23 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_24 = {
  class: "data-table-td"
};
const _hoisted_25 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_26 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_27 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_28 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_29 = {
  class: "data-table-td text-slate-700"
};
const _hoisted_30 = {
  class: "data-table-td"
};
const _hoisted_31 = {
  class: "flex justify-end gap-1.5"
};
const _hoisted_32 = ["disabled", "title", "aria-label", "onClick"];
const _hoisted_33 = {
  key: 0,
  class: "fixed inset-0 z-[60]",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "编辑部门日报规则"
};
const _hoisted_34 = {
  class: "department-rule-editor-panel absolute inset-y-0 right-0 flex h-full flex-col bg-white shadow-2xl"
};
const _hoisted_35 = {
  class: "flex shrink-0 items-center justify-between border-b border-slate-200 px-5 py-4"
};
const _hoisted_36 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_37 = {
  class: "space-y-4"
};
const _hoisted_38 = {
  class: "block"
};
const _hoisted_39 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_40 = {
  class: "block"
};
const _hoisted_41 = {
  class: "block"
};
const _hoisted_42 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_43 = {
  class: "block"
};
const _hoisted_44 = {
  class: "block"
};
const _hoisted_45 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_46 = {
  class: "form-switch"
};
const _hoisted_47 = {
  class: "grid gap-4 sm:grid-cols-2"
};
const _hoisted_48 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_49 = {
  class: "form-switch"
};
const _hoisted_50 = {
  class: "mt-3 block"
};
const _hoisted_51 = ["disabled"];
const _hoisted_52 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_53 = {
  class: "rounded-lg border border-slate-200 bg-white px-3 py-3"
};
const _hoisted_54 = {
  class: "form-switch"
};
const _hoisted_55 = {
  class: "mt-3 block"
};
const _hoisted_56 = ["disabled"];
const _hoisted_57 = {
  class: "mt-1 text-xs text-slate-500"
};
const _hoisted_58 = {
  class: "mt-6 flex justify-end gap-3 border-t border-slate-200 pt-5"
};
const _hoisted_59 = ["disabled"];
import { computed, reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { ArrowPathIcon, Cog6ToothIcon, ExclamationTriangleIcon, InboxIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/vue/24/outline';
import { getLeaderDepartmentWorkReportRules, saveDepartmentWorkReportRule } from '@/api/workReport';
import { buildDepartmentRulePayload, createDepartmentRuleForm, formatDateRange, formatReminderOffset, formatRuleTime, isInheritedRule, normalizeLeaderDepartmentRules } from '../composables/workReportDepartmentRules.mjs';
import { isValidDateRange, isValidDeadlineTime, parsePositiveIntegerId } from '../composables/workReportGovernanceValidation.mjs';
export default {
  __name: 'DepartmentRuleDrawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const departmentRows = ref([]);
    const editingDepartment = ref(null);
    const loading = ref(false);
    const loadError = ref(false);
    const submitting = ref(false);
    const editorVisible = ref(false);
    const ruleForm = reactive(createDepartmentRuleForm());
    const summaryCards = computed(() => {
      const total = departmentRows.value.length;
      const inherited = departmentRows.value.filter(row => isInheritedRule(row)).length;
      const configured = Math.max(0, total - inherited);
      return [{
        label: '负责部门',
        value: total,
        hint: '当前可管理范围',
        tone: 'text-slate-500'
      }, {
        label: '部门规则',
        value: configured,
        hint: '已覆盖默认规则',
        tone: 'text-blue-600'
      }, {
        label: '继承系统默认',
        value: inherited,
        hint: '使用公共默认规则',
        tone: 'text-slate-500'
      }];
    });
    const editorTitle = computed(() => isInheritedRule(editingDepartment.value) ? '配置规则' : '编辑规则');
    watch(() => props.modelValue, visible => {
      if (visible) loadDepartments();
    });
    function closeDrawer() {
      if (submitting.value) return;
      emit('update:modelValue', false);
    }
    async function loadDepartments() {
      loading.value = true;
      loadError.value = false;
      try {
        departmentRows.value = normalizeLeaderDepartmentRules(await getLeaderDepartmentWorkReportRules());
      } catch {
        departmentRows.value = [];
        loadError.value = true;
      } finally {
        loading.value = false;
      }
    }
    function openEditor(row) {
      if (row.editable === false) return;
      editingDepartment.value = row;
      Object.assign(ruleForm, createDepartmentRuleForm(row));
      editorVisible.value = true;
    }
    function closeEditor() {
      if (!submitting.value) editorVisible.value = false;
    }
    async function submitRule() {
      if (!validateRuleForm()) return;
      submitting.value = true;
      try {
        await saveDepartmentWorkReportRule(buildDepartmentRulePayload(ruleForm));
        ElMessage.success('部门日报规则已保存');
        editorVisible.value = false;
        await loadDepartments();
      } catch (error) {
        ElMessage.error(error?.message || '部门日报规则保存失败，请稍后重试');
      } finally {
        submitting.value = false;
      }
    }
    function validateRuleForm() {
      if (parsePositiveIntegerId(ruleForm.departmentId) === null) {
        ElMessage.warning('缺少有效部门');
        return false;
      }
      if (parsePositiveIntegerId(ruleForm.versionNo) === null || !ruleForm.effectiveFrom) {
        ElMessage.warning('请填写生效日期');
        return false;
      }
      if (!isValidDateRange(ruleForm.effectiveFrom, ruleForm.effectiveTo)) {
        ElMessage.warning('生效日期不能晚于失效日期');
        return false;
      }
      if (!isValidDeadlineTime(ruleForm.planDeadline) || !isValidDeadlineTime(ruleForm.summaryDeadline)) {
        ElMessage.warning('请填写有效的截止时间');
        return false;
      }
      if (ruleForm.teamPlanReminderEnabled && !Number.isInteger(Number(ruleForm.teamPlanReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的团队计划提醒时间');
        return false;
      }
      if (ruleForm.teamSummaryReminderEnabled && !Number.isInteger(Number(ruleForm.teamSummaryReminderOffsetMinutes))) {
        ElMessage.warning('请填写有效的团队总结提醒时间');
        return false;
      }
      return true;
    }
    return (_ctx, _cache) => {
      const _directive_modal_a11y = _resolveDirective("modal-a11y");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [__props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/60 backdrop-blur-sm",
        onClick: closeDrawer
      }), _createElementVNode("aside", _hoisted_2, [_createElementVNode("header", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(Cog6ToothIcon), {
        class: "h-5 w-5"
      })]), _cache[10] || (_cache[10] = _createElementVNode("div", null, [_createElementVNode("h2", {
        class: "text-lg font-semibold text-slate-900"
      }, "部门日报规则"), _createElementVNode("p", {
        class: "mt-0.5 text-sm text-slate-500"
      }, "配置你作为部门负责人可管理部门的日报规则。")], -1))]), _createElementVNode("button", {
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
        title: "关闭",
        "aria-label": "关闭",
        onClick: closeDrawer
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-5 w-5"
      })])]), _createElementVNode("main", _hoisted_6, [_createElementVNode("section", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(summaryCards.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.label,
          class: "rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm"
        }, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.value), 1), _createElementVNode("div", {
          class: _normalizeClass(["mt-1 text-xs", item.tone])
        }, _toDisplayString(item.hint), 3)]);
      }), 128))]), _createElementVNode("section", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_cache[12] || (_cache[12] = _createElementVNode("div", null, [_createElementVNode("h3", {
        class: "text-base font-semibold text-slate-900"
      }, "负责部门"), _createElementVNode("p", {
        class: "mt-0.5 text-sm text-slate-500"
      }, "所有部门默认继承系统规则，你只需要为负责的部门新增覆盖规则。")], -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        disabled: loading.value,
        onClick: loadDepartments
      }, [_createVNode(_unref(ArrowPathIcon), {
        class: "h-4 w-4"
      }), _cache[11] || (_cache[11] = _createTextVNode(" 刷新 ", -1))], 8, _hoisted_12)]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[13] || (_cache[13] = [_createElementVNode("div", {
        class: "app-spinner"
      }, null, -1), _createElementVNode("span", {
        class: "text-sm text-slate-500"
      }, "正在加载负责部门规则...", -1)]))])) : loadError.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_unref(ExclamationTriangleIcon), {
        class: "h-6 w-6 text-rose-500"
      })]), _cache[14] || (_cache[14] = _createElementVNode("p", {
        class: "text-sm text-slate-600"
      }, "部门规则加载失败，请稍后重试。", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-secondary mt-1",
        onClick: loadDepartments
      }, "重试")])) : departmentRows.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_unref(InboxIcon), {
        class: "h-6 w-6 text-slate-400"
      })]), _cache[15] || (_cache[15] = _createElementVNode("span", {
        class: "empty-state-title"
      }, "暂无可管理的负责部门", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("table", _hoisted_19, [_cache[16] || (_cache[16] = _createElementVNode("thead", {
        class: "data-table-head"
      }, [_createElementVNode("tr", null, [_createElementVNode("th", {
        class: "data-table-th text-left"
      }, "部门"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "日报功能"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "计划截止"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "计划提醒"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "总结截止"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "总结提醒"), _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "生效区间"), _createElementVNode("th", {
        class: "data-table-th text-right"
      }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(departmentRows.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.departmentId,
          class: "transition-colors hover:bg-slate-50/80"
        }, [_createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(row.departmentName || '--'), 1), _createElementVNode("div", _hoisted_23, "ID " + _toDisplayString(row.departmentId || '--'), 1)]), _createElementVNode("td", _hoisted_24, [_createElementVNode("span", {
          class: _normalizeClass(["status-badge", row.rule?.dailyReportEnabled === false ? 'bg-slate-100 text-slate-600' : 'bg-emerald-50 text-emerald-700'])
        }, _toDisplayString(row.rule?.dailyReportEnabled === false ? '关闭' : '开启'), 3)]), _createElementVNode("td", _hoisted_25, _toDisplayString(_unref(formatRuleTime)(row.rule?.planDeadline)), 1), _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(formatReminderOffset)(row.rule?.teamPlanReminderEnabled, row.rule?.teamPlanReminderOffsetMinutes)), 1), _createElementVNode("td", _hoisted_27, _toDisplayString(_unref(formatRuleTime)(row.rule?.summaryDeadline)), 1), _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(formatReminderOffset)(row.rule?.teamSummaryReminderEnabled, row.rule?.teamSummaryReminderOffsetMinutes)), 1), _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatDateRange)(row.rule)), 1), _createElementVNode("td", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("button", {
          type: "button",
          class: "table-action-button is-primary",
          disabled: row.editable === false,
          title: _unref(isInheritedRule)(row) ? '配置规则' : '编辑规则',
          "aria-label": _unref(isInheritedRule)(row) ? '配置规则' : '编辑规则',
          onClick: $event => openEditor(row)
        }, [_createVNode(_unref(PencilSquareIcon), {
          class: "h-4 w-4"
        })], 8, _hoisted_32)])])]);
      }), 128))])])]))])])]), editorVisible.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", {
        class: "absolute inset-0 bg-slate-900/40",
        onClick: closeEditor
      }), _createElementVNode("aside", _hoisted_34, [_createElementVNode("header", _hoisted_35, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_36, _toDisplayString(editorTitle.value), 1), _cache[17] || (_cache[17] = _createElementVNode("p", {
        class: "mt-0.5 text-sm text-slate-500"
      }, "保存后更新该部门的日报规则配置。", -1))]), _createElementVNode("button", {
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600",
        title: "关闭",
        "aria-label": "关闭",
        onClick: closeEditor
      }, [_createVNode(_unref(XMarkIcon), {
        class: "h-5 w-5"
      })])]), _createElementVNode("form", {
        class: "min-h-0 flex-1 overflow-y-auto bg-slate-50 px-5 py-5",
        onSubmit: _withModifiers(submitRule, ["prevent"])
      }, [_createElementVNode("div", _hoisted_37, [_createElementVNode("label", _hoisted_38, [_cache[18] || (_cache[18] = _createElementVNode("span", {
        class: "form-label"
      }, "部门", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ruleForm.departmentName = $event),
        class: "form-readonly mt-1 w-full",
        readonly: ""
      }, null, 512), [[_vModelText, ruleForm.departmentName]])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("label", _hoisted_40, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "form-label"
      }, [_createTextVNode("生效日期 "), _createElementVNode("span", {
        class: "text-red-500"
      }, "*")], -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ruleForm.effectiveFrom = $event),
        class: "form-input form-date mt-1 w-full",
        type: "date"
      }, null, 512), [[_vModelText, ruleForm.effectiveFrom]])]), _createElementVNode("label", _hoisted_41, [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "form-label"
      }, "失效日期", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ruleForm.effectiveTo = $event),
        class: "form-input form-date mt-1 w-full",
        type: "date"
      }, null, 512), [[_vModelText, ruleForm.effectiveTo]])])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("label", _hoisted_43, [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "form-label"
      }, "计划截止", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ruleForm.planDeadline = $event),
        class: "form-input mt-1 w-full",
        type: "time"
      }, null, 512), [[_vModelText, ruleForm.planDeadline]])]), _createElementVNode("label", _hoisted_44, [_cache[22] || (_cache[22] = _createElementVNode("span", {
        class: "form-label"
      }, "总结截止", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ruleForm.summaryDeadline = $event),
        class: "form-input mt-1 w-full",
        type: "time"
      }, null, 512), [[_vModelText, ruleForm.summaryDeadline]])])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("label", _hoisted_46, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ruleForm.dailyReportEnabled = $event),
        class: "form-switch-input",
        type: "checkbox"
      }, null, 512), [[_vModelCheckbox, ruleForm.dailyReportEnabled]]), _cache[23] || (_cache[23] = _createElementVNode("span", {
        class: "form-switch-track"
      }, null, -1)), _cache[24] || (_cache[24] = _createElementVNode("span", {
        class: "form-switch-label"
      }, "开启团队日报要求", -1))]), _cache[25] || (_cache[25] = _createElementVNode("p", {
        class: "mt-1 text-xs leading-5 text-slate-500"
      }, "关闭后该部门不计入团队应交和团队提醒，员工仍可主动提交日报。", -1))]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("label", _hoisted_49, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ruleForm.teamPlanReminderEnabled = $event),
        class: "form-switch-input",
        type: "checkbox"
      }, null, 512), [[_vModelCheckbox, ruleForm.teamPlanReminderEnabled]]), _cache[26] || (_cache[26] = _createElementVNode("span", {
        class: "form-switch-track"
      }, null, -1)), _cache[27] || (_cache[27] = _createElementVNode("span", {
        class: "form-switch-label"
      }, "团队计划提醒", -1))]), _createElementVNode("label", _hoisted_50, [_cache[28] || (_cache[28] = _createElementVNode("span", {
        class: "form-label"
      }, "相对计划截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ruleForm.teamPlanReminderOffsetMinutes = $event),
        class: "form-input mt-1 w-full",
        type: "number",
        disabled: !ruleForm.teamPlanReminderEnabled
      }, null, 8, _hoisted_51), [[_vModelText, ruleForm.teamPlanReminderOffsetMinutes, void 0, {
        number: true
      }]])]), _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(formatReminderOffset)(ruleForm.teamPlanReminderEnabled, ruleForm.teamPlanReminderOffsetMinutes)), 1)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("label", _hoisted_54, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ruleForm.teamSummaryReminderEnabled = $event),
        class: "form-switch-input",
        type: "checkbox"
      }, null, 512), [[_vModelCheckbox, ruleForm.teamSummaryReminderEnabled]]), _cache[29] || (_cache[29] = _createElementVNode("span", {
        class: "form-switch-track"
      }, null, -1)), _cache[30] || (_cache[30] = _createElementVNode("span", {
        class: "form-switch-label"
      }, "团队总结提醒", -1))]), _createElementVNode("label", _hoisted_55, [_cache[31] || (_cache[31] = _createElementVNode("span", {
        class: "form-label"
      }, "相对总结截止（分钟）", -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ruleForm.teamSummaryReminderOffsetMinutes = $event),
        class: "form-input mt-1 w-full",
        type: "number",
        disabled: !ruleForm.teamSummaryReminderEnabled
      }, null, 8, _hoisted_56), [[_vModelText, ruleForm.teamSummaryReminderOffsetMinutes, void 0, {
        number: true
      }]])]), _createElementVNode("p", _hoisted_57, _toDisplayString(_unref(formatReminderOffset)(ruleForm.teamSummaryReminderEnabled, ruleForm.teamSummaryReminderOffsetMinutes)), 1)])])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("button", {
        type: "button",
        class: "btn-secondary",
        onClick: closeEditor
      }, "取消"), _createElementVNode("button", {
        type: "submit",
        class: "btn-primary",
        disabled: submitting.value
      }, _toDisplayString(submitting.value ? '保存中' : '保存规则'), 9, _hoisted_59)])], 32)])])), [[_directive_modal_a11y, closeEditor]]) : _createCommentVNode("", true)])), [[_directive_modal_a11y, closeDrawer]]) : _createCommentVNode("", true)]);
    };
  }
};